import amapi from '@/api/amapi'

/**
 * Wrapper around FileReader API
 * @param inputFile { File }
 * @returns {Promise} Formatted file
 */
export function readUploadedFile (inputFile) {
  const temporaryFileReader = new FileReader()

  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort()
      reject(new DOMException('Problem parsing input file.'))
    }

    temporaryFileReader.readAsDataURL(inputFile)

    temporaryFileReader.onload = () => {
      resolve({
        file: temporaryFileReader.result,
        file_name: inputFile.name,
        file_size: inputFile.size,
        file_type: inputFile.type,
      })
    }
  })
}

/**
 * Return true if file mime type match to allowed types
 * @param file
 * @param allowed - Array
 * @returns {*}
 */
export function checkMimeType (file, allowed) {
  return allowed.includes(file.type)
}

/**
 * Return true if file size matched allowed size
 * @param file
 * @param size - Number
 * @returns {boolean}
 */
export function checkFileSize (file, size) {
  const allowed_size = size * 1048576
  return file.size < allowed_size
}

/**
 * Upload file
 * @param file
 * @returns {Number} ID of a uploaded file
 */
export async function uploadFile (file) {
  try {
    const { id } = await amapi.makecall('fileupload', { ...file })
    return id
  } catch (e) {
    throw e
  }
}

/**
 * Delete file by id
 * @param id ID of a file
 * @returns {Promise<any|undefined>}
 */
export async function deleteFile (id = null) {
  try {
    return await amapi.makecall('filedelete', { id })
  } catch (e) {
    throw e
  }
}
